import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
export function UrgencyTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 3,
    minutes: 47,
    seconds: 23
  });
  const [cuposRestantes] = useState(37);
  const totalCupos = 200;
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) {
          seconds--;
        } else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        } else {
          // Reset timer
          hours = 3;
          minutes = 47;
          seconds = 23;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const percentage = (totalCupos - cuposRestantes) / totalCupos * 100;
  return <section className="w-full max-w-4xl mx-auto px-4 py-8" data-id="element-145" data-mp="1p8a6m5l53gd4">
      <div className="bg-gradient-to-r from-red-50 to-orange-50 border-2 border-red-200 rounded-lg p-6" data-id="element-146" data-mp="2qa97777uxa3y">
        <div className="flex items-center justify-center gap-2 mb-4" data-id="element-147" data-mp="2v43pq7bq7j1g">
          <ClockIcon className="w-6 h-6 text-red-600" data-id="element-148" data-mp="2gepcup8xyjhb" />
          <h3 className="text-xl font-bold text-red-700" data-id="element-149" data-mp="2gbth97kkg6w1">
            ¡Oferta por tiempo limitado!
          </h3>
        </div>

        <div className="flex justify-center gap-4 mb-6" data-id="element-150" data-mp="391sazg9pgs71">
          <div className="bg-white rounded-lg px-4 py-3 text-center min-w-[70px]" data-id="element-151" data-mp="3908ov91dbmxc">
            <div className="text-3xl font-bold text-gray-900" data-id="element-152" data-mp="3e0n1l4dwzl1p">
              {String(timeLeft.hours).padStart(2, '0')}
            </div>
            <div className="text-xs text-gray-500 uppercase" data-id="element-153" data-mp="3438nhbfgr8ck">Horas</div>
          </div>
          <div className="bg-white rounded-lg px-4 py-3 text-center min-w-[70px]" data-id="element-154" data-mp="3451uirtznul3">
            <div className="text-3xl font-bold text-gray-900" data-id="element-155" data-mp="1nr399gzpreug">
              {String(timeLeft.minutes).padStart(2, '0')}
            </div>
            <div className="text-xs text-gray-500 uppercase" data-id="element-156" data-mp="3vb8rit2rqnhh">Minutos</div>
          </div>
          <div className="bg-white rounded-lg px-4 py-3 text-center min-w-[70px]" data-id="element-157" data-mp="3qbw5ubnmvmgh">
            <div className="text-3xl font-bold text-gray-900" data-id="element-158" data-mp="3qe08kq9sqff6">
              {String(timeLeft.seconds).padStart(2, '0')}
            </div>
            <div className="text-xs text-gray-500 uppercase" data-id="element-159" data-mp="3gmmbsq98btpq">Segundos</div>
          </div>
        </div>

        <div className="mb-3" data-id="element-160" data-mp="3bnsx4ui7hwnz">
          <div className="flex justify-between text-sm mb-2" data-id="element-161" data-mp="3bo2reuaaapzh">
            <span className="font-semibold text-gray-700" data-id="element-162" data-mp="37kwitfzp8mpu">Cupos restantes</span>
            <span className="font-bold text-red-600" data-id="element-163" data-mp="32ljo692l6bcp">
              {cuposRestantes} / {totalCupos}
            </span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-3 overflow-hidden" data-id="element-164" data-mp="2xoa0oyyrc9ri">
            <div className="bg-gradient-to-r from-red-500 to-orange-500 h-full rounded-full transition-all duration-500" style={{
            width: `${percentage}%`
          }} data-id="element-165" data-mp="10uyir5xc6lc7" />
          </div>
        </div>

        <p className="text-center text-sm text-gray-600" data-id="element-166" data-mp="13da80h19vfx4">
          Los bonos gratuitos solo están disponibles durante esta oferta
        </p>
      </div>
    </section>;
}